import React, { useState } from "react";
import { Type, X } from "lucide-react";
import { setItemFields, removeItemFields } from "../../services/catalogService";

const ItemFieldsEditor = ({ selectedIds, fieldDefinitions, onClose, onDone }) => {
    const [fieldDefId, setFieldDefId] = useState(fieldDefinitions[0]?.id || "");
    const [value, setValue] = useState("");
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState("");

    const handleApply = async () => {
        if (!fieldDefId) return;
        setSaving(true);
        setError("");
        try {
            if (value.trim() === "") {
                await removeItemFields(selectedIds, fieldDefId);
            } else {
                await setItemFields(selectedIds, fieldDefId, value.trim());
            }
            onDone();
        } catch (e) {
            setError(e.message || "Failed to save");
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center p-4" onClick={onClose}>
            <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md p-6" onClick={(e) => e.stopPropagation()}>
                <div className="flex items-center justify-between mb-4">
                    <h2 className="font-bold text-gray-800 flex items-center gap-2"><Type size={18} className="text-purple-600" /> Set Custom Field</h2>
                    <button onClick={onClose} className="text-gray-400 hover:text-gray-600"><X size={18} /></button>
                </div>
                <p className="text-xs text-gray-400 mb-4">Applies to {selectedIds.length} selected item{selectedIds.length === 1 ? "" : "s"}. Leave the value blank to clear this field.</p>

                {fieldDefinitions.length === 0 ? (
                    <p className="text-sm text-gray-400 mb-4">No custom fields defined yet — add one in Settings first.</p>
                ) : (
                    <>
                        <label className="text-xs font-semibold text-gray-600 mb-1 block">Field</label>
                        <select value={fieldDefId} onChange={(e) => setFieldDefId(e.target.value)}
                            className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm mb-4 focus:outline-none focus:border-teal-500">
                            {fieldDefinitions.map((f) => <option key={f.id} value={f.id}>{f.name}</option>)}
                        </select>

                        <label className="text-xs font-semibold text-gray-600 mb-1 block">Value</label>
                        <input value={value} onChange={(e) => setValue(e.target.value)}
                            placeholder="Enter a value..."
                            className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm mb-4 focus:outline-none focus:border-teal-500" />
                    </>
                )}

                {error && <div className="mb-4 bg-red-50 border border-red-200 rounded-xl p-3 text-red-700 text-xs">{error}</div>}

                <button onClick={handleApply} disabled={saving || !fieldDefId}
                    className="w-full py-2.5 bg-gradient-to-r from-purple-500 to-blue-600 text-white rounded-xl font-bold hover:opacity-90 transition disabled:opacity-40">
                    {saving ? "Saving..." : `Apply to ${selectedIds.length} Item${selectedIds.length === 1 ? "" : "s"}`}
                </button>
            </div>
        </div>
    );
};

export default ItemFieldsEditor;